<template>
  <div><PageTable /></div>
</template>

<script>
import PageTable from './components/table'
export default {
  name: 'production-packReportRecord',
  components: { PageTable },
}
</script>
